
@if (documents.length > 0) {
  <div class="content-container bg-white-no-shadow">
    <div class="table-responsive">
      <h5>{{ 'common.document.viewTitle' | translate }}</h5>
      <table class="table table-striped" [attr.aria-label]="'common.document.viewTitle' | translate">
        <thead>
          <tr>
            <th scope="col" translate="common.document.table.title"></th>
            <th scope="col"></th>
          </tr>
        </thead>
        <tbody>
          @for (doc of documents; track doc) {
            <tr>
              <td class="align-middle">{{ doc.title }}</td>
              <td class="text-end">
                <button class="btn btn-link btn-sm" type="button"
                  (click)="downloadItem(doc)"
                  title="{{'common.tooltip.download' | translate}}">
                  <fa-icon [icon]="icons.download"></fa-icon>
                </button>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>
}
